module.exports = __webpack_public_path__ + "img/UA.60def14f.svg";